(function (angular) {
    angular.module('bizPartEngage').directive('bizLeaderboard', bizLeaderboardDirective);

    bizLeaderboardDirective.$inject = ["bizCore"];

    function bizLeaderboardDirective(bizCoreProvider) {
        var directive = {
            restrict: "E",
            scope: {
                leaderboard: "=",
                header: "@"
            },
            templateUrl: bizCoreProvider.getView('core.directives.leaderboard', "FrontEnd/Core/Directives/Views/Leaderboard.html"),
            controller: bizHeaderController,
            controllerAs: "vm",
            bindToController: true
        }

        bizHeaderController.$inject = ["bizUser"];

        function bizHeaderController(bizUser) {
            var vm = this;

            vm.IsMe = IsMe;

            function IsMe(user) {
                return user.UserId == bizUser.getLoggedInUser().Id;
            }
        }

        return directive;
    }
})(window.angular);
